<section class="page-section">
    <form (ngSubmit)="onSave(f)" #f="ngForm" autocomplete="off">
        <div class="row">
            <div class="col-4">
                <mat-card>
                    <mat-card-content>
                        <mat-form-field>
                            <input matInput
                                   type="text"
                                   name="name"
                                   #name="ngModel"
                                   ngModel
                                   required
                                   placeholder="Name">
                            <mat-error *ngIf="name.hasError('required')">
                                Name is <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                        <button type="submit"
                                mat-raised-button color="primary"
                                [disabled]="f.form.invalid">Save
                        </button>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </form>
</section>
